import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Icon } from '../Icon';
import style from './Drawer.module.css';
const Drawer = ({ isOpen, children, onClose, title = '', subtitle = '', showCloseButton = true, closeOnBackdropClick = true, onReturn, customStyles, }) => {
    const drawerRef = useRef(null);
    const styles = { ...style, ...customStyles };
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                if (onReturn) {
                    onReturn();
                    return;
                }
                onClose();
            }
        };
        if (!closeOnBackdropClick) {
            return;
        }
        document.addEventListener('keydown', handleEscapeKey);
        return () => document.removeEventListener('keydown', handleEscapeKey);
    }, [isOpen, onClose, onReturn, closeOnBackdropClick]);
    useEffect(() => {
        const handleOutsideClick = (event) => {
            const hasOpenModal = !!document.body.getAttribute('data-open-modals');
            if (hasOpenModal)
                return;
            const target = event.target;
            const targetElement = target instanceof Element ? target : null;
            const shouldIgnoreOutsideClick = Boolean(targetElement?.closest('[data-ibk-outside-click-ignore="true"]'));
            if (shouldIgnoreOutsideClick)
                return;
            if (drawerRef.current && target && !drawerRef.current.contains(target) && isOpen) {
                onClose();
            }
        };
        if (!closeOnBackdropClick) {
            return;
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [isOpen, onClose, closeOnBackdropClick]);
    useEffect(() => {
        const body = document.body;
        const root = document.getElementById('root');
        if (isOpen) {
            const originalBodyOverflow = body.style.overflowY;
            const originalRootOverflow = root?.style.overflowY;
            body.style.overflowY = 'hidden';
            if (root) {
                root.style.overflowY = 'hidden';
            }
            return () => {
                body.style.overflowY = originalBodyOverflow;
                if (root) {
                    root.style.overflowY = originalRootOverflow ?? '';
                }
            };
        }
    }, [isOpen]);
    const handleBackdropClick = () => {
        if (closeOnBackdropClick) {
            onClose();
        }
    };
    const handleBackdropKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleBackdropClick();
        }
    };
    return (_jsxs(_Fragment, { children: [isOpen && (_jsx("button", { type: 'button', className: styles['drawer-overlay'], onClick: handleBackdropClick, onKeyDown: handleBackdropKeyDown, "aria-label": 'Close drawer backdrop', "data-testid": 'drawer-overlay' })), _jsx("div", { ref: drawerRef, className: `${style.drawer} ${isOpen ? styles['drawer-open'] : styles['drawer-closed']}`, children: _jsxs("div", { className: styles['drawer-content'], children: [_jsxs("div", { className: styles['drawer-header-container'], children: [_jsxs("div", { className: styles['drawer-header'], children: [_jsxs("div", { className: styles['drawer-header-left'], children: [!!onReturn && (_jsx("button", { className: styles['drawer-close-btn'], onClick: onReturn, "aria-label": 'Close drawer', children: _jsx(Icon, { name: 'arrowChevronLeftGray', alt: '<', "data-testid": `img-drawer-header-chevron-left` }) })), _jsx("div", { className: styles['drawer-header-title'], children: title })] }), showCloseButton && (_jsx("button", { className: styles['drawer-close-btn'], onClick: onClose, "aria-label": 'Close drawer', children: _jsx(Icon, { name: 'actionCloseOrange', alt: 'actionCloseOrange', "data-testid": `img-drawer-header-close` }) }))] }), subtitle && _jsx("div", { className: styles['drawer-header-subtitle'], children: subtitle })] }), _jsx("div", { className: styles['drawer-body'], children: children })] }) })] }));
};
export default Drawer;
